module.exports = __webpack_public_path__ + "img/reparacion (1).62148bcb.jpg";